export interface ProgramExerciseSeed {
  id: string; // referencia a EXERCISE_LIBRARY
  sets: number;
  repsMin: number;
  repsMax: number;
  rir: number | null;
  notes?: string;
}

export interface ProgramDaySeed {
  label: string;
  exercises: ProgramExerciseSeed[];
}

// Programa de recomposición corporal a 4 días, pecho entrenado 2 veces por semana
// (Día 1 y Día 4) y foco extra en cintura/core, siguiendo el objetivo del boceto original.
export const FULL_PROGRAM: ProgramDaySeed[] = [
  {
    label: "Día 1 · Empuje (pecho)",
    exercises: [
      { id: "press-banca", sets: 4, repsMin: 6, repsMax: 8, rir: 2 },
      { id: "press-banca-inclinado", sets: 3, repsMin: 8, repsMax: 10, rir: 2 },
      { id: "aperturas-polea", sets: 3, repsMin: 10, repsMax: 12, rir: 1 },
      { id: "elevaciones-laterales", sets: 3, repsMin: 12, repsMax: 15, rir: 1 },
      { id: "extension-polea", sets: 3, repsMin: 10, repsMax: 12, rir: 1 },
    ],
  },
  {
    label: "Día 2 · Tirón (espalda)",
    exercises: [
      { id: "remo-barra", sets: 4, repsMin: 6, repsMax: 8, rir: 2 },
      { id: "jalon-pecho", sets: 3, repsMin: 8, repsMax: 10, rir: 2 },
      { id: "remo-polea-sentado", sets: 3, repsMin: 10, repsMax: 12, rir: 1 },
      { id: "face-pull", sets: 3, repsMin: 12, repsMax: 15, rir: 1 },
      { id: "curl-mancuernas", sets: 3, repsMin: 10, repsMax: 12, rir: 1 },
    ],
  },
  {
    label: "Día 3 · Pierna",
    exercises: [
      { id: "sentadilla", sets: 4, repsMin: 6, repsMax: 8, rir: 2 },
      { id: "peso-muerto-rumano", sets: 3, repsMin: 8, repsMax: 10, rir: 2 },
      { id: "prensa", sets: 3, repsMin: 10, repsMax: 12, rir: 1 },
      { id: "zancadas", sets: 3, repsMin: 10, repsMax: 12, rir: 1, notes: "por pierna" },
      { id: "talones-pie", sets: 4, repsMin: 12, repsMax: 15, rir: 1 },
    ],
  },
  {
    label: "Día 4 · Empuje + cintura",
    exercises: [
      { id: "press-mancuernas", sets: 3, repsMin: 8, repsMax: 10, rir: 2 },
      { id: "aperturas-mancuernas", sets: 3, repsMin: 10, repsMax: 12, rir: 1 },
      { id: "press-hombro-mancuernas", sets: 3, repsMin: 8, repsMax: 10, rir: 2 },
      { id: "plancha", sets: 3, repsMin: 30, repsMax: 45, rir: null, notes: "segundos" },
      { id: "giros-rusos", sets: 3, repsMin: 16, repsMax: 20, rir: 1, notes: "total, ambos lados" },
    ],
  },
];
